import React, { useState, useContext, useEffect } from 'react';
import { Redirect } from 'react-router-dom';

import UserContext from '../../../contexts/UserContext';
import {
    Tab,
    TabProps,
    Dimmer,
    Loader,
    Button,
    Dropdown,
    Checkbox,
    Icon,
    Input,
    Select,
    Divider,
    Form,
} from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { updateActivity, saveActivity, deleteActivity, listCommunityActivities } from '../../../services/community';

import './style.less';
import DailyActivity from './dailyActivity';
import DailyActivityForm from './dailyActivityForm';

const DailyActivities = () => {
    const [lastUpdated, setLastUpdated] = useState(Date.now());
    const {
        userObject: {
            registrants: { list: listOfResidents, activeRegistrantsIndexes },
            profile: { _id: userId },
        },
    } = useContext(UserContext);

    const [menuDate, setMenuDate] = useState(new Date());
    const [activityList, setActivityList] = useState([]);
    const [loading, setLoading] = useState(true);

    const saveActivityItem = async (menuItem) => {
        try {
            await saveActivity(userId, menuItem);
            fetchActivities();
        } catch (e) {
            console.log(e);
        }
    };

    const updateActivityItem = async (activity) => {
        try {
            await updateActivity(userId, activity);
            fetchActivities();
        } catch (e) {
            console.log(e);
        }
    };

    const deleteActivityItem = async (activityId) => {
        try {
            await deleteActivity(userId, activityId);
            fetchActivities();
        } catch (e) {
            console.log(e);
        }
    };

    const fetchActivities = async () => {
        setLoading(true);
        try {
            //Extend this to take page number
            const activityList = await listCommunityActivities(userId);
            console.log(activityList);
            setActivityList(activityList);
        } catch (e) {
            console.log(e);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchActivities();
    }, []);

    return (
        <div className=" food-menu">
            {/* <MenuItemForm menuItem={ {dateString: new Date(), category: "breakfast"}} saveHandler={saveMenu}/> */}
            <Dimmer active={loading} inverted>
                <Loader active={loading} />
            </Dimmer>
            <h2>Create Community Activity</h2>

            <DailyActivityForm
                activity={{ startTime: Date.now() }}
                saveHandler={saveActivityItem}
                cancelHandler={undefined}
            />
            <Divider />

            {activityList &&
                activityList.length &&
                activityList.map((activity) => {
                    const { _id } = activity;
                    return (
                        <DailyActivity
                            activity={activity}
                            key={_id}
                            updateHandler={updateActivityItem}
                            deleteHandler={deleteActivityItem}
                        />
                    );
                })}
            {/* {menuList()} */}
        </div>
    );
};

export default DailyActivities;
